import React, { Component } from 'react'

import ContMessageI18N from '../../containers/ContMessageI18N';
import NumberFormatCustom from '../std/NumberFormatCustom';

class TestAccessory extends Component {

	constructor(props) {
		super(props);
		this.state = TestAccessory.getStateFromProps(props);
		this.onChange = props.onChange;
	}
	static getStateFromProps(props) {
		return {
			key: props.data.key,
			amountExclTax: props.data.pricing.amountExclTax,
			amountInclTax: props.data.pricing.amountInclTax,
			isMounted: props.data.isMounted == null ? undefined : props.data.isMounted,

		};
	}
	static getDerivedStateFromProps(props, currentState) {
		if (currentState !== TestAccessory.getStateFromProps(props)) {
			return TestAccessory.getStateFromProps(props);
		}
		return null;
	}

	onChange = function (data) { }

	handleChange(data, name) {
		var updateVar = {};
		for (var keys in this.state) {
			updateVar[keys] = this.state[keys];
		}
		updateVar[name] = data[name];
		var accessory = { key: updateVar.key, pricing: {} };
		if (updateVar.amountExclTax != null) {
			accessory.pricing.amountExclTax = updateVar.amountExclTax * 1.0;
		}
		if (updateVar.amountInclTax != null) {
			accessory.pricing.amountInclTax = updateVar.amountInclTax * 1.0;
		}
		if (updateVar.isMounted != null) {
			accessory.isMounted = updateVar.isMounted;
		}
		this.onChange(accessory);
	}

	handleChangeCheck = name => event => {
		var newValue = event.target.checked;
		if (name === 'isMounted') {
			this.handleChange({ isMounted: newValue }, 'isMounted');
		}
	};

	handleChangeGeneric = name => event => { this.handleChange({ [name]: event.target.value }, name); };
	getLabel(fieldname, i18nKey) { return this.props.settings.isDevelopperView ? fieldname : this.getMessage(i18nKey); }
	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }
	render() {
		const amountInclTaxName = 'amountInclTax';
		const amountExclTaxName = 'amountExclTax';
		const accessoryPrefix = 'accessory-';
		return (
			<React.Fragment>
				<div className="col-auto form-floating">
					<input id={`${accessoryPrefix}${this.state.key}`} type="text" className="form-control"
						placeholder={this.getLabel('key', 'generics.key')}
						value={this.state.key} onChange={this.handleChangeGeneric('key')} />
					<label htmlFor={`${accessoryPrefix}${this.state.key}`}>{this.getLabel('key', 'generics.key')}</label>
				</div>
				<div className="col-auto form-floating">
					<NumberFormatCustom id={`${accessoryPrefix}${this.state.key}-amountExclTax`} className="form-control"
						placeholder={this.getLabel(amountExclTaxName, 'vehicle.pricing.amountExclTax')}
						value={this.state.amountExclTax} onChange={this.handleChangeGeneric(amountExclTaxName)} />
					<label htmlFor={`${accessoryPrefix}${this.state.key}-amountExclTax`}>
						{this.getLabel(amountExclTaxName, 'vehicle.pricing.amountExclTax')}
					</label>
				</div>
				<div className="col-auto form-floating">
					<NumberFormatCustom id={`${accessoryPrefix}${this.state.key}-amountInclTax`} className="form-control"
						placeholder={this.getLabel(amountInclTaxName, 'vehicle.pricing.amountInclTax')}
						value={this.state.amountInclTax} onChange={this.handleChangeGeneric(amountInclTaxName)} />
					<label htmlFor={`${accessoryPrefix}${this.state.key}-amountInclTax`}>
						{this.getLabel(amountInclTaxName, 'vehicle.pricing.amountInclTax')}
					</label>
				</div>
				<div className="col-auto form-check">
					<input className="form-check-input" type="checkbox" value={this.state.isMounted}
						id={`${accessoryPrefix}${this.state.key}-isMounted`} onChange={this.handleChangeCheck('isMounted')} />
					<label className="form-check-label" htmlFor={`${accessoryPrefix}${this.state.key}-isMounted`}>
						{this.getLabel('isMounted', 'vehicle.accessories.isMounted')}
					</label>
				</div>
			</React.Fragment>
		)
	}
}

export default (TestAccessory)

